import { render, staticRenderFns } from "./dplayer.vue?vue&type=template&id=b7acb014&scoped=true&"
import script from "./dplayer.vue?vue&type=script&lang=js&"
export * from "./dplayer.vue?vue&type=script&lang=js&"
import style0 from "./dplayer.vue?vue&type=style&index=0&id=b7acb014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7acb014",
  null
  
)

export default component.exports